export function queryString(params) {
    if (!params || typeof params !== "object") {
        return "";
    }
    return Object.keys(params)
        .map((key) => {
            return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
        })
        .join("&");
}

export function checkValidURL(target, times, delay, timeoutMs = 2000) {
    return new Promise((res, rej) => {
        const attempt = (remaining) => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                console.warn(`[checkValidURL] timeout after ${timeoutMs}ms for ${target}`);
                controller.abort();
            }, timeoutMs);

            fetch(target, { mode: "no-cors", signal: controller.signal })
                .then((response) => {
                    clearTimeout(timeoutId);
                    res(response);
                })
                .catch((err) => {
                    clearTimeout(timeoutId);
                    if (remaining === 0) {
                        return rej(err);
                    }
                    setTimeout(() => attempt(remaining - 1), delay);
                });
        };

        attempt(times);
    });
}
